import { logo } from '../../../../configs/Icons';
import { useInit } from '../../../Contexts/InitProvider';

function TopRightCol({ info }) {
    const { initInfo } = useInit();

    const { phoneNumber, organization, email, address } = info?.invConfig || {};

    return (
        <div className="sm:w-[370px] flex items-start gap-x-3">
            <img
                src={initInfo?.adminLogo || logo.mainLogoW}
                alt="logo"
                className="w-[calc(100%_-_236px)] mt-[5px]"
            />
            <div className="w-56">
                <h2 className="text-xl text-primary-700 font-bold mb-3">
                    <span>{organization || '--'}</span>
                </h2>
                <div className="text-sm opacity-70">
                    <p className="mb-1">
                        <span>{address || '--'}</span>
                    </p>
                    <div>
                        <p>
                            <span>{phoneNumber || '--'}</span>
                        </p>
                        <p>
                            <span>{email || '--'}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopRightCol;
